import { render, staticRenderFns } from "./qyzx.vue?vue&type=template&id=47bad4a6&scoped=true"
import script from "./qyzx.vue?vue&type=script&lang=js"
export * from "./qyzx.vue?vue&type=script&lang=js"
import style0 from "./qyzx.vue?vue&type=style&index=0&id=47bad4a6&prod&lang=less"
import style1 from "./qyzx.vue?vue&type=style&index=1&id=47bad4a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bad4a6",
  null
  
)

export default component.exports